import { render, staticRenderFns } from "./BuilderProjectOverview.vue?vue&type=template&id=1ebf0412&"
import script from "./BuilderProjectOverview.vue?vue&type=script&lang=js&"
export * from "./BuilderProjectOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports